import React from 'react'
import { Typography, Input } from 'antd'

const { Text, Title } = Typography
const { Search } = Input;

class SearchForm extends React.PureComponent {

    onSearchInput = (e) =>{
        this.props.onSearchData(e.target.value)
    }

	render() {
		const { title, subtitle } = this.props
		return (
			<>
                    <Text level={4} className="mb-5 mr-3">
                        ค้นหา : 
                    </Text>
                    <Input.Search
                        placeholder=""
                        onChange={ this.onSearchInput }
                        style={{ width: "50%" }}
                    />
			</>
		)
	}
}

export default SearchForm